module.exports = __webpack_public_path__ + "static/media/detail-after.ab0f57c6.png";